/** List knowledge base articles */
export const kbArticleListSpec = {
    uri: '/kb/article/list',
    method: 'POST',
    allowAnonymous: true,
};
